import select from './select';
export default function min(array, selector) {
    const values = select(array, selector);
    return Math.min(...values);
}
